// src/store.ts
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import settingsReducer from './slices/settings';
import profilesReducer from './slices/profiles';
import mapReducer from './slices/map';

const rootReducer = combineReducers({
  settings: settingsReducer,
  profiles: profilesReducer,
  map: mapReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['settings', 'profiles', 'map'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
